/** shortcutAllowed guards global single-key shortcuts: not while typing,
 * not with modifiers held, and not while a dialog is open. */
export function shortcutAllowed(e: KeyboardEvent): boolean {
  if (e.metaKey || e.ctrlKey || e.altKey) return false;
  const el = document.activeElement;
  if (
    el instanceof HTMLInputElement ||
    el instanceof HTMLTextAreaElement ||
    el instanceof HTMLSelectElement ||
    (el instanceof HTMLElement && el.isContentEditable)
  ) {
    return false;
  }
  if (document.querySelector('[role="dialog"]')) return false;
  return true;
}
